<template>
  <div v-if="typeOt">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" v-if="$route.params.id">
                  {{ $t('addEditTypeOt.title.edit', { nom: libelle }) }}</h1>
                <h1 class="title is-size-3" v-else>
                  {{ $t('addEditTypeOt.title.add') }}</h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="is-pulled-right buttons boutonAction">
              <a class="button"
                @click="$router.go(-1)">
                {{ $t('general.button.cancel') }}
              </a>
              <a class="button is-addOrEdit" @click="save">
                {{ $t('general.button.sauvegarder') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <error-msg-component class="mgt-20px"
      :messages="messages"
      :messagesChampsVide="messagesChampsVide"
      :champsVide="champsVide"
      :error="error"
      :title="'general.problemOccurred'"
      :withEmplyFields="true"
      @close="error = $event"/>

    <div class="columns is-multiline">
      <div class="column is-12 mgt-20px">
        <infoGeneral :typeOt="typeOt"/>
      </div>
      <div class="column is-12">
        <addEditViewTaches :typeOt="typeOt"/>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { get, update, create } from '@/api/logistique/typeOt/index';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import breadcrumb from '@/components/general/breadcrumb';
import validationGenerale from '@/services/validation/validation';
import translate from '@/services/logistique/typeOt/translatorTypeOt';
import genererTypeOt from '@/services/logistique/typeOt/genererTypeOt';
import infoGeneral from '@/components/logistique/typeOt/addEdit/infoGeneralTypeOt';
import addEditViewTaches from '@/components/logistique/typeOt/addEdit/addEditViewTaches';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    breadcrumb,
    errorMsgComponent,
    infoGeneral,
    addEditViewTaches,
  },
  data() {
    return {
      typeOt: null,
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      libelle: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('addEditTypeOt.breadcrumb.liste'), route: { name: 'l.logistique.type_ot' }, isActive: false },
        {
          title: this.$route.params.id ? this.$t('addEditTypeOt.breadcrumb.edit') : this.$t('addEditTypeOt.breadcrumb.add'),
          route: { name: '' },
          isActive: true,
        },
      ];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let typeOt;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        this.error = false;
        this.typeOt.societeId = this.societeActiveId;
        if (this.$route.params.id) {
          typeOt = (await update(this.typeOt)).data.result;
          messageSuccess(this.$t('addEditTypeOt.success.edit'));
        } else {
          typeOt = (await create(this.typeOt)).data.result;
          messageSuccess(this.$t('addEditTypeOt.success.add'));
        }
        await this.loadParametreForce(PARAMETRES_KEYS.typeOt);
        await this.$router.push(({ name: 'c.logistique.type_ot', params: { id: typeOt.id } }));
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationGenerale(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.id) {
        this.typeOt = (await get(this.$route.params.id)).data.result;
        this.libelle = cloneDeep(this.typeOt.libelle);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.typeOt.libelle }));
      } else {
        this.typeOt = genererTypeOt();
        this.setInformationPage(this.$t('pageLogistique.typeOt.creation'));
      }
      loadingComponent.close();
    } catch (error) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw error;
    }
  },
};
</script>
